import Vue from 'vue';
import {handleErrors} from '@/services/ErrorHandling';

const self = Vue.prototype;

export default {
  getCurrencies() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminCurrency)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  }
}
